import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft, Clock } from "lucide-react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FloatingWhatsApp from "../components/site/FloatingWhatsApp";
import { WhatsAppButton } from "../components/site/CTAs";
import { WhatsAppIcon } from "../components/site/Logo";
import useSEO from "../hooks/useSEO";
import { track } from "../lib/tracking";
import { waLink, WHATSAPP_ENABLED } from "../config";

export default function Grazie() {
  const { state } = useLocation();
  const nome = state?.nome?.split(" ")[0] || "";

  useSEO({
    title: "Grazie per la tua richiesta | Muratore Imbianchino Roma",
    description: "Abbiamo ricevuto la tua richiesta di preventivo. Ti ricontattiamo al più presto.",
    path: "/grazie",
  });

  useEffect(() => {
    // Primary conversion event for Google Ads / Meta / GA4
    track.formSubmit({ page: "grazie", tipo_lavoro: state?.tipo, priorita: state?.priorita });
  }, [state]);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-28 sm:py-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-xl w-full text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.2 }}
            className="mx-auto h-20 w-20 rounded-full bg-brand-orange/15 flex items-center justify-center text-brand-orange"
          >
            <CheckCircle2 size={44} />
          </motion.div>

          <h1 className="mt-7 font-display font-extrabold tracking-tight text-navy text-4xl sm:text-5xl">
            Grazie{nome ? `, ${nome}` : ""}!
          </h1>
          <p className="mt-4 text-ink/65 text-lg">
            Abbiamo ricevuto la tua richiesta di preventivo. Ti ricontatteremo nel più breve tempo possibile.
          </p>

          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-surface px-4 py-2 text-sm text-ink/70">
            <Clock size={16} className="text-brand-orange" /> Risposta rapida, in genere in giornata
          </div>

          <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3">
            {WHATSAPP_ENABLED && (
              <a
                href={waLink("Ciao! Ho appena inviato una richiesta di preventivo dal sito.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="grazie-whatsapp"
                onClick={() => track.whatsappClick("grazie")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-4 font-semibold text-white shadow-[0_10px_28px_-8px_rgba(37,211,102,0.8)] hover:bg-[#1ebe5b] transition-colors"
              >
                <WhatsAppIcon size={20} /> Anticipa su WhatsApp
              </a>
            )}
            <Link
              to="/"
              data-testid="grazie-home"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-navy/20 px-7 py-4 font-semibold text-navy hover:bg-navy hover:text-white transition-colors"
            >
              <ArrowLeft size={18} /> Torna alla home
            </Link>
          </div>

          {WHATSAPP_ENABLED && (
            <p className="mt-10 text-sm text-ink/45">
              Nel frattempo puoi inviarci qualche foto in più su WhatsApp per un preventivo ancora più preciso.
            </p>
          )}
        </motion.div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
